import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { getClientView, listClientViewPublicUsers } from "../../api/adminClientViewsApi";
import RequirePermission from "../../auth/RequirePermission";
import { formatDateTime } from "../../components/midpoint/admin/users/adminUserFormatters";

function ClientViewPublicUsersPageContent() {
  const { clientViewId } = useParams();
  const [clientView, setClientView] = useState(null);
  const [users, setUsers] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    Promise.all([getClientView(clientViewId), listClientViewPublicUsers(clientViewId)])
      .then(([viewBody, usersBody]) => {
        setClientView(viewBody.clientView);
        setUsers(usersBody.users || []);
      })
      .catch((error) => {
        setErrorMessage(error.message || "Unable to load public users.");
      });
  }, [clientViewId]);

  return (
    <div className="midpoint-admin-page">
      <header className="panel-card">
        <p className="eyebrow">Client View</p>
        <h1>Public users — {clientView?.name || "…"}</h1>
        <p className="muted">
          Consumer accounts with sessions on this published Client View.
        </p>
        <div className="cv-studio-page__actions">
          <Link className="midpoint-share-button" to={`/admin/client-views/${clientViewId}/studio`}>
            Back to Studio
          </Link>
        </div>
      </header>

      {errorMessage ? (
        <section className="panel-card">
          <p>{errorMessage}</p>
        </section>
      ) : (
        <section className="panel-card">
          <table className="admin-data-health-table">
            <thead>
              <tr>
                <th>Email</th>
                <th>Name</th>
                <th>Saved listings</th>
                <th>Saved searches</th>
                <th>Last login</th>
              </tr>
            </thead>
            <tbody>
              {users.length ? (
                users.map((user) => (
                  <tr key={user.publicUserId}>
                    <td>{user.email}</td>
                    <td>
                      {[user.firstName, user.lastName].filter(Boolean).join(" ") || "—"}
                    </td>
                    <td>{user.savedListingsCount ?? 0}</td>
                    <td>{user.savedSearchesCount ?? 0}</td>
                    <td>{user.lastLoginAt ? formatDateTime(user.lastLoginAt) : "—"}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={5}>No public users with sessions on this view yet.</td>
                </tr>
              )}
            </tbody>
          </table>
        </section>
      )}
    </div>
  );
}

export default function ClientViewPublicUsersPage() {
  return (
    <RequirePermission permission="client_views.view">
      <ClientViewPublicUsersPageContent />
    </RequirePermission>
  );
}
